import { makeApiUrl } from 'main/factories/http';
import { makeAuthorizeHttpClientDecorator } from 'main/factories/decorators';
import { GetAiPrompts } from 'domain/usecases/ai/get-ai-prompts';
import { RemoteGetAiPrompts } from 'data/usecases/ai/remote-get-ai-prompts';

export const makeGetAiPrompts = (): GetAiPrompts => {
  return new RemoteGetAiPrompts(makeApiUrl(`/ai/prompts`), makeAuthorizeHttpClientDecorator());
};
